import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon';
import { cloneObject } from '../../common/utils';

class Picture extends React.Component {
  constructor() {
    super();
    this.state = {
      isLoading: true,
      isUnavailable: false
    };
  }

  componentDidMount() {
    const {
      props: {
        src
      }
    } = this;

    const errorState = {
      isLoading: false,
      isUnavailable: true
    };

    if (src) {
      const preloadedImage = new Image();
      preloadedImage.onerror = () => this.setState(errorState);
      preloadedImage.onabort = () => this.setState(errorState);
      preloadedImage.onload = () => this.setState({ isLoading: false });
      preloadedImage.src = src;
    }

    else {
      this.setState({ isLoading: false });
    }
  }

  render() {
    const {
      props,
      state: {
        isLoading,
        isUnavailable
      }
    } = this;

    const {
      itemIconName = 'camera',
      src,
      alt,
      className: frameClass = '',
      ratio,
      width,
      height
    } = props;

    const imgAttributes = {
      ...cloneObject(props, {}, [
        'itemIconName',
        'className',
        'alt',
        'ratio'
      ]),
      className: 'item-picture'
    };

    const frameClasses = ['picture-frame'];
    const wrapperClasses = ['picture-appearance-controller'];
    const wrapperStyles = {};

    if (frameClass) {
      frameClasses.push(frameClass);
    }

    if (isLoading) {
      wrapperClasses.push('is-loading');
    }

    if (isUnavailable) {
      wrapperClasses.push('is-unavailable');
    }

    if (ratio) {
      const { 0: ratioWidth, 1: ratioHeight } = ratio.split(':');
      wrapperClasses.push('fixed-crop-ratio');
      wrapperStyles.paddingBottom = `${(ratioHeight / ratioWidth) * 100}%`;
    }

    if (width) {
      wrapperStyles.maxWidth = width;
    }

    if (height) {
      wrapperStyles.maxHeight = height;
    }

    const wrapperAttributes = {
      className: wrapperClasses.join(' '),
      style: wrapperStyles
    };

    return (
      <div className={frameClasses.join(' ')}>
        <div {...wrapperAttributes}>
          {isLoading ? null : (
            <React.Fragment>
              {!isUnavailable && src ? <img {...imgAttributes} alt={alt} /> : (
                <Icon
                  iconName={!src ? itemIconName : 'file-image'}
                  className='icon-item-picture-placeholder'
                />
              )}
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}

Picture.propTypes = {
  itemIconName: PropTypes.string,
  alt: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  ratio(props, propName, componentName) {
    const regex = /^\d*:\d*$/;
    const value = props[propName];
    if (value && !regex.test(value)) {
      return new Error(
        `Invalid prop "${propName}" passed to "${componentName}". 
        Expected format: {number}:{number} - got: ${value}`
      );
    }
  }
};

export default Picture;